import { Link } from 'react-router-dom';
import { EmptyState } from '../components/EmptyState';
import SEO from '../components/SEO';
import { Button } from '../components/ui/button';

export default function NotFound() {
  const currentPath = typeof window !== 'undefined' ? window.location.pathname : '/404';
  return (
    <div data-testid="page-not-found" className="container">
      <SEO
        title="Page Not Found"
        description="This page couldn't be found."
        path={currentPath}
        noindex
      />
      <EmptyState
        eyebrow="404"
        title="This trail leads nowhere — yet."
        description="The page you were looking for has moved, been renamed, or perhaps never existed. Let's get you back on the path."
        action={
          <div className="flex gap-3">
            <Button asChild data-testid="notfound-home"><Link to="/">Return home</Link></Button>
            <Button asChild variant="outline" data-testid="notfound-shop"><Link to="/shop">Browse the catalog</Link></Button>
          </div>
        }
        testId="notfound"
      />
    </div>
  );
}
